import React from "react";
import { useTranslation } from "react-i18next";

const SectionCard = ({ section }) => {
  if (!section) {
    return null;
  }

  const paragraphs = Array.isArray(section.paragraphs) ? section.paragraphs : [];
  const items = Array.isArray(section.items) ? section.items : [];

  return (
    <article className="bg-white/5 p-6 md:p-8 rounded-2xl border border-white/10 shadow-2xl shadow-slate-900/50 space-y-4">
      {section.title && (
        <h2 className="text-2xl font-semibold text-cyan-300">{section.title}</h2>
      )}
      {paragraphs.map((text, index) => (
        <p key={index} className="text-gray-200 leading-relaxed">
          {text}
        </p>
      ))}
      {items.length > 0 && (
        <ul className="list-disc list-inside text-gray-200 space-y-2">
          {items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      )}
    </article>
  );
};

const PolicyPage = ({ policyKey }) => {
  const { t } = useTranslation();
  const policy = t(`policies.${policyKey}`, { returnObjects: true });

  if (!policy || typeof policy !== "object") {
    return null;
  }

  const sections = Array.isArray(policy.sections) ? policy.sections : [];

  return (
    <section className="bg-slate-900 text-white py-16 px-4">
      <div className="max-w-5xl mx-auto space-y-10">
        <header className="space-y-4">
          {policy.categoryLabel && (
            <p className="text-xs uppercase tracking-[0.3em] text-cyan-300">
              {policy.categoryLabel}
            </p>
          )}
          <div>
            {policy.title && (
              <h1 className="text-3xl md:text-4xl font-bold">{policy.title}</h1>
            )}
            {policy.lastUpdated && (
              <p className="text-sm text-gray-400 mt-2">{policy.lastUpdated}</p>
            )}
          </div>
          {policy.intro && <p className="text-gray-200">{policy.intro}</p>}
        </header>

        <div className="space-y-6">
          {sections.map((section, index) => (
            <SectionCard key={`section-${index}`} section={section} />
          ))}
        </div>

        {policy.contact && (
          <div className="bg-cyan-900/30 border border-cyan-500/50 rounded-2xl p-6 space-y-3">
            {policy.contact.label && (
              <p className="text-xs uppercase tracking-[0.3em] text-cyan-200">
                {policy.contact.label}
              </p>
            )}
            {policy.contact.title && (
              <h3 className="text-xl font-semibold">{policy.contact.title}</h3>
            )}
            {policy.contact.description && (
              <p className="text-gray-200">{policy.contact.description}</p>
            )}
            {policy.contact.email && (
              <a
                href={`mailto:${policy.contact.email}`}
                className="text-cyan-300 hover:text-cyan-100 underline decoration-dotted"
              >
                {policy.contact.email}
              </a>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default PolicyPage;
